import { z } from 'zod';

// Validated at boot (imported from main.tsx). A missing/invalid var throws
// immediately rather than surfacing as a confusing runtime failure later.
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_OTEL_ENABLED: z.string(),
  VITE_OTEL_SIGNALS_BASE_URL: z.string().url(),
  VITE_IS_ANALYTICS_ENABLED: z.string(),
  VITE_MIXPANEL_TOKEN: z.string(),
  VITE_MIXPANEL_API_HOST: z.string(),
  VITE_UNIFIED_SDK_URL: z.string().url(),
});

export type Env = z.infer<typeof envSchema>;

export const env: Env = envSchema.parse(import.meta.env);
